import React, {Component} from 'react';
import axios from 'axios';
import { store } from 'react-notifications-component';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import inicio from '../tools/images/inicio.png';
import sedes from '../tools/images/sedes.png';
import convenios from '../tools/images/convenios.png';
import horarios from '../tools/images/horarios.png';
import reportes from '../tools/images/reporte.png';
import img from '../tools/images/logo.png';
import ico from '../tools/images/medicall24logo.png';
import '../tools/css/Sidebar.css';
import { Alert } from 'react-bootstrap';


const ApiURL="https://medicall-api-test.azurewebsites.net";
var Institution =sessionStorage.getItem('institution');
var Avatar ="https://medicall-api-test.azurewebsites.net/api/Files?path="+sessionStorage.getItem('avatar');
var mensaje='';



class Sidebar_profesional extends Component  {

  esRutaActiva = (ruta) => {
    return window.location.pathname === ruta;
  }

  esGrupoActivo = (rutas) => {
    return rutas.includes(window.location.pathname);
  }

   render(){

    const grupoFacturacionActivo = this.esGrupoActivo(['/tablero_RDA', '/facturacion', '/informes_facturas']);
    const grupoConfigActivo = this.esGrupoActivo(['/ajustes', '/perfil', '/publicaciones']);

    return (

  <aside className="main-sidebar sidebar-dark-primary elevation-4">
  {/* Brand Logo */}
  <a href="/inicio_profesional" className="brand-link" id="item_ips">
    <img src={Avatar} alt="Logo" className="brand-image img-circle elevation-4" />
    <span title={Institution.toUpperCase()} className="brand-text font-weight-light">{Institution.toUpperCase()}</span>
  </a>
  {/* Sidebar */}
  <div id="sidebar_personalizado" className="sidebar">
   
    {/* Sidebar Menu */}
    <nav className="mt-2">
      <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        {/* Add icons to the links using the .nav-icon class
         with font-awesome or any other icon font library */}
        <li className="nav-item">
          <a href="/inicio_profesional" className={`nav-link${this.esRutaActiva('/inicio_profesional') ? ' activo' : ''}`}>
            <i className="nav-icon fas fa-home"></i>
            <p>Inicio
            </p>
          </a>
        </li>

        <li className="nav-item">
          <a href="/citas_profesional" className={`nav-link${this.esRutaActiva('/citas_profesional') ? ' activo' : ''}`}>
          <i className="nav-icon fas fa-file-contract"></i>
            <p>
              Asignación de citas
            </p>
          </a>
        </li>

        <li className="nav-item">
          <a href="/agenda_profesional" className={`nav-link${this.esRutaActiva('/agenda_profesional') ? ' activo' : ''}`}>
          <i class="nav-icon far fa-calendar-alt"></i>
            <p>
              Agenda
            </p>
          </a>
        </li>

        <li className={`nav-item has-treeview${grupoFacturacionActivo ? ' menu-open' : ''}`}>
          <a href="#" className={`nav-link${grupoFacturacionActivo ? ' activo-grupo' : ''}`}>
            <i className="nav-icon fas fa-solid fa-file-invoice-dollar" />
            <p>
              Facturación - IHCE
              <i className="fas fa-angle-left right" />
            </p>
          </a>
          <ul className="nav nav-treeview">
            <li className="nav-item">
              <a href="/tablero_RDA" className={`nav-link${this.esRutaActiva('/tablero_RDA') ? ' activo' : ''}`}>
              <i className="nav-icon fas fa-solid fa-network-wired"></i>
                <p>IHCE</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/facturacion" className={`nav-link${this.esRutaActiva('/facturacion') ? ' activo' : ''}`}>
                <i className="nav-icon fas fa-solid fa-file-invoice-dollar" />
                <p>Facturación</p>
              </a>
            </li>
            <hr></hr>
            <li className="nav-item">
              <a href="/informes_facturas" className={`nav-link${this.esRutaActiva('/informes_facturas') ? ' activo' : ''}`}>
                <i className="nav-icon fas fa-solid fa-chart-pie" />
                <p>Informes</p>
              </a>
            </li>

          </ul>
        </li>
        
      
        
        <li className="nav-header">OPCIONES</li>        
        
        <li className={`nav-item has-treeview${grupoConfigActivo ? ' menu-open' : ''}`}>
          <a href="#" className={`nav-link${grupoConfigActivo ? ' activo-grupo' : ''}`}>
            <i className="nav-icon fas fa-cog" />
            <p>
              Configuración
              <i className="fas fa-angle-left right" />
            </p>
          </a>
          <ul className="nav nav-treeview">
          <li className="nav-item">
              <a href="/ajustes" className={`nav-link${this.esRutaActiva('/ajustes') ? ' activo' : ''}`}>
                <i className="nav-icon fas fa-cogs" />
                <p>Ajustes</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/perfil" className={`nav-link${this.esRutaActiva('/perfil') ? ' activo' : ''}`}>
                <i className="nav-icon fas fa-user" />
                <p>Perfil</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/publicaciones" className={`nav-link${this.esRutaActiva('/publicaciones') ? ' activo' : ''}`}>
                <i className="nav-icon far fa-newspaper" />
                <p>Publicaciones</p>
              </a>
            </li>
            <li className="nav-item">
              <a href="/" onClick={()=> sessionStorage.clear()} className="nav-link">
              <i class="nav-icon fas fa-sign-out-alt"></i>
                <p>Cerrar sesión</p>
              </a>
            </li>
          </ul>
        </li>
              
       
        
        
       
       
        
      </ul>
    </nav>
    {/* /.sidebar-menu */}
  </div>
  {/* /.sidebar */}

</aside>







    )
  }

}

export default Sidebar_profesional;